<script lang="ts" setup>
  import { ref, watch } from "vue";
  import { themingCssClass } from "vue/applications/frontend/mixins/theming-mixin"

  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "mehr",
    },
  });
  const value = ref<any>(props.modelValue);
  watch(()=>props.modelValue, (newValue)=>{
    value.value = newValue;
  })

  defineEmits(["update:model-value"])
</script>

<template>
  <div
    class="components__score-item-show-more-button more"
    v-bind:class="[themingCssClass('normal')]"
    v-on:click="$emit('update:model-value', !value)"
  >
    <span class="more-label">{{ label }}</span>
    <span class="icon">
      <template v-if="value">
        <i class="frontend-icon fi-expand_less"></i>
      </template>
      <template v-else>
        <i class="frontend-icon fi-expand_more"></i>
      </template>
    </span>
  </div>
</template>

<style lang="scss" scoped>
@import "~stylesheets/frontend/variables/colors";
.components__score-item-show-more-button {
  &.more {
    font-size: 14px;
    cursor: pointer;
    margin-top: 15px;

    .more-label {
      margin-right: 5px;
    }
  }
}
</style>
